import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.section`
	min-height: 70vh;
	display: flex;
	place-items: center;

	.section-wrapper {
		padding: 8em 0;

		.sections-wrapper {
			max-width: 35%;
			margin: 2em auto;

			.layout-button {
				justify-content: center;
			}
		}
	}

	.success-send-email {
		text-align: center;
		margin: 1em auto 2em auto;
		font-size: 1.1em;
	}

	@media all and (max-width: ${vars.tabletL}) {
		.section-wrapper {
			.sections-wrapper {
				max-width: 100%;
				padding: 0 2em;
			}
		}
	}

`;
